<script>
  // The quest edit page's Generated Quests tab: the template's occurrences by
  // lifecycle — Current (live, highlighted), Next (soonest first) and Historical
  // (newest first, paged server-side on `history_page`). `quests` is the
  // controller's { current, next, historical, historical_pagy } prop; the card
  // handlers pass straight through to GeneratedQuestCard.
  import { router } from '@inertiajs/svelte'
  import dayjs from 'dayjs'
  import GeneratedQuestCard from './generated_quest_card.svelte'
  import Paginator from '../paginator.svelte'
  import { Badge } from '../ui'

  let { quests = null, ...handlers } = $props()

  const current = $derived(quests?.current ?? [])
  const upcoming = $derived(quests?.next ?? [])
  const historical = $derived(quests?.historical ?? [])
  const historyPagy = $derived(quests?.historical_pagy)
  const empty = $derived(current.length === 0 && upcoming.length === 0 && historical.length === 0)

  const showHistoryPage = (page) =>
    router.reload({ only: ['quests'], data: { history_page: page }, preserveScroll: true })
</script>

<div class="max-w-4xl">
  <p class="text-sm text-base-content/60 mb-5">
    The template's Quest occurrences: the one live now, what's scheduled next, and past ones for review. Each card
    shows the visible and active windows and the quest prompt. Saving the template updates these occurrences in place —
    schedule changes move them, and new dates appear here shortly after saving — so the app picks the change up on its
    next read. Use <strong>Create Example</strong> to create the quest's Zupp-authored reference post (pinned first in
    Moments; the only moment shown while Coming Soon).
  </p>

  {#if empty}
    <p class="text-base-content/60 py-4">
      No generated quests yet. They appear a few seconds after you save the template; the daily 4am ET job keeps future
      occurrences topped up.
    </p>
  {:else}
    <section class="mb-8">
      <h3 class="flex items-center gap-2 font-semibold mb-3">Current <Badge variant="success" size="sm">Live</Badge></h3>
      {#each current as quest (quest.id)}
        <GeneratedQuestCard {quest} highlighted {...handlers} />
      {:else}
        <p class="text-sm text-base-content/60">
          No quest is live right now.{#if upcoming[0]}&nbsp;Next starts {dayjs(upcoming[0].active_starts_at).format('MMM D, h:mma')}.{/if}
        </p>
      {/each}
    </section>

    <section class="mb-8">
      <h3 class="flex items-center gap-2 font-semibold mb-3">
        Next <span class="font-normal text-base-content/60">({upcoming.length})</span>
      </h3>
      {#each upcoming as quest (quest.id)}
        <GeneratedQuestCard {quest} {...handlers} />
      {:else}
        <p class="text-sm text-base-content/60">Nothing scheduled yet — the daily 4am ET job tops these up.</p>
      {/each}
    </section>

    <section class="mb-8">
      <h3 class="flex items-center gap-2 font-semibold mb-3">
        Historical <span class="font-normal text-base-content/60">({historyPagy?.count ?? historical.length})</span>
      </h3>
      {#each historical as quest (quest.id)}
        <GeneratedQuestCard {quest} {...handlers} />
      {:else}
        <p class="text-sm text-base-content/60">No past occurrences yet.</p>
      {/each}
      {#if historyPagy && historical.length > 0}
        <Paginator {...historyPagy} param="history_page" onpage={showHistoryPage} />
      {/if}
    </section>
  {/if}
</div>
